import Api from "./Api";

export default {
  getUserEntities(params) {
    let searchByName = '';
    if (params === undefined || params == null) {
      params = {
        page: 1
      };
    } else {
      if (params.page === undefined) params.page = 1;
      if (params.name !== '' && params.name !== undefined) {
        searchByName = `&name=${params.name}`;
      }
    }
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    return Api().get(`/list-user-all-entities/${userId}?page=${params.page}${searchByName}`);
  },

  getAllUserEntities() {
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    return Api().get(`/list-user-all-entities/${userId}`);
  },

  getUserProfile() {
    return Api().get(`/get-profile`);
  },

  getUserEntitiesForPreReg(userId) {
    return Api().get(`/list-user-all-entities/${userId}`);
  }
};
